<template>
    <b-container fluid>
      <b-container>
        <small><label>Επιλογή Ακαδημαϊκού Έτους</label></small>
        <b-row class="breakPoint">
          <b-col sm="10">
            <b-form-select v-model="selected" :options="options">
              <template slot="first">
                <option value="null" disabled>-- Παρακαλώ επιλέξτε έτος --</option>
              </template>
            </b-form-select>
          </b-col>
          <b-button
            size="sm"
            variant="outline-info"
            @click="searchDepartments">Αναζήτηση
          </b-button>
        </b-row>
      </b-container>

      <div class="loading-parent">
        <loading :active.sync="isLoading"
                 :is-full-page="fullPage"></loading>
      </div>

      <b-container fluid  v-show="searchEnable">
        <department-list-component></department-list-component>
      </b-container>

    </b-container>
</template>

<script>

  import requests from '../../js/DistributionRequestService';
  import Utils from '../../js/AppUtilities';
  import {GlobalEudoxusBus} from '../../js/DistributionRequestService';
  import {GlobalEudoxusData} from '../../main.js'
  import DepartmentListComponent from './DepartmentListComponent';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.min.css';


  export default {

    data() {
      return {
        isLoading: false,
        fullPage: true,
        searchEnable: false,
        selected: null,
        current: null,
        institutionsArray: [],
        academicArray: [],
        tableMap: [],
        objectMap: [],
        options: []
      }
    },
    components: {
      'loading': Loading,
      'departmentListComponent': DepartmentListComponent
    },
    methods: {
      searchDepartments() {
        this.isLoading = true;
        if (this.selected != null) {
          requests.getSelectedSecretariats(requests.getDistributionPointId(), this.selected, this.fillUpDataTable);
        } else {
          this.isLoading = false;
          alert("Παρακαλώ επιλέξτε Έτος")
        }
      },
      fillUpDataTable(resultArray) {
        this.tableMap = Utils.departmentMapResolver(resultArray);
        let tableData = [];
        tableData.push({currentYear: this.current, selectedYear: this.selected, tableDeparts: this.tableMap});
        GlobalEudoxusBus.$emit('departmentTableSetup',  tableData);
        this.searchEnable = true;
        this.isLoading = false;
      },
      setUpComponent() {
        this.institutionsArray = [];
        this.academicArray = [];
        this.objectMap = [];
        requests.getAcademicYearsSelect("Department", this.selectOptions);
        requests.getSecretariats(this.setUpInstitutionSecretariatMap);
      },
      setUpInstitutionSecretariatMap(resultArray) {
        if (resultArray.length > 0)
          this.institutionsArray.push({institutionId: resultArray[0].institution.id, institutionName: resultArray[0].institution.name});

        for (let i=0; i<resultArray.length; i++) {
          let academicObj = {academicId: resultArray[i].academic.id, academicName: resultArray[i].academic.department, secretariatId: resultArray[i].secretariat.id};
          this.academicArray.push(academicObj);
        }

        this.academicArray.sort(Utils.compareAcademic);

        this.objectMap.push({institution: this.institutionsArray, academic: this.academicArray, selectedYear: this.selected});
        GlobalEudoxusBus.$emit('selectorsSetup', this.objectMap);
      },
      selectOptions(object) {
        this.current = object[0].value;
        this.options = object;
      }
    },
    created() {
      GlobalEudoxusBus.$on('globalSetupEvent', globalSetupEvent => {
        if (globalSetupEvent)
          this.setUpComponent();
      });
    }
  }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/DepartmentsTabComponents/SelectDepartmentComponent.vue